import React, { Component } from 'react';
import { DOMAINS_WITHOUT_LINKING } from 'templates/seo';
import PropTypes from 'prop-types';
import { translatable } from 'services/Intl';


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLinks: false,
    };
  }

  toggleLinks() {
    const { showLinks } = this.state;
    this.setState({ showLinks: !showLinks });
  }

  render() {
    const { links, domain, t } = this.props;
    const { showLinks } = this.state;
    return (
      <header className="landing-page__header">
        <div className="landing-page__header__wrapper">
          <a className="landing-page__header__link" href="/">
            <img alt="logo hundredrooms" className="landing-page__header__link__logo" src="https://static.100r.systems/img/general/logo.svg" />
            <img alt="Hundredrooms logo" className="header-molecule__logo__image__img-text" src="https://static.100r.systems/img/general/HR-Logo-Horizontal.svg" />
          </a>
          { (links && links.length > 0 && !DOMAINS_WITHOUT_LINKING.includes(domain))
            && (
              <nav className="landing-page__header__nav">
                <ul className="landing-page__header__nav__links">
                  <li className="landing-page__header__nav__links__link" onClick={ this.toggleLinks.bind(this) }>
                    <p className="landing-page__header__nav__links__link__text">
                      { t("accommodation types") }
                    </p>
                  </li>
                </ul>
                <div className={ `landing-page__header__links ${showLinks ? '-is-showed' : ''}` }>
                  <div className="landing-page__header__links__container">
                    {
                      !links ? null
                        : links.map((list, i) => (
                          <ul key={ `landing-page__header__links__list-${i}` } className="landing-page__header__links__list">
                            <li className="landing-page__header__links__list__item__title">
                              { list.data.length ? list.title : '' }
                            </li>
                            {
                              !list.data ? null
                                : list.data.map((link, a) => (
                                  <li key={ `landing-page__header__links__list__item-${a}` } className="landing-page__header__links__list__item">
                                    <a className="landing-page__header__links__list__item__link" href={ link.url.endsWith('/') ? link.url : `${link.url}/` }>
                                      { link.title }
                                    </a>
                                  </li>
                                ))
                            }
                          </ul>
                        ))
                    }
                  </div>
                </div>
              </nav>
            )
          }
        </div>
      </header>
    );
  }
}

Header.defaultProps = {
  links: [],
};

Header.propTypes = {
  domain: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      links: PropTypes.arrayOf(
        PropTypes.shape({
          href: PropTypes.string,
          name: PropTypes.string,
        })
      ),
      title: PropTypes.string,
    })
  ),
  t: PropTypes.func.isRequired,
};

export default translatable(Header);
